import {
  BaseQueryApi,
  FetchArgs,
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react'
import { store } from 'store'

import { STORAGE_NAMES } from 'services/storage/storageNames'

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.BASE_URL || '/api/',
  prepareHeaders: headers => {
    const token = localStorage.getItem(STORAGE_NAMES.ACCESS_TOKEN)
    if (token) {
      headers.set('Authorization', `Token ${JSON.parse(token)}`)
    }
  },
  credentials: 'include',
})

const baseQueryErrHandler = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: {},
) => {
  let result = await baseQuery(args, api, extraOptions)
  try {
    const url = typeof args === 'object' ? args.url : args
    if (result?.error && url.includes('auth/me/systems')) {
      return result
    }

    if (result.error && 'data' in result.error) {
      // @ts-ignore
      if (typeof result.error?.data?.warning === 'object') {
        // @ts-ignore
        store.dialogStore.openErrorModal(result.error?.data?.warning)
      } else {
        const text = result.error?.data
        if (typeof text === 'string') {
          store.dialogStore.openErrorModal({ text })
        }
      }
    }
  } catch (error) {}
  return result
}

export const CreateLogisticTagType = 'CreateLogisticTagType'
export const CreateLogisticCartTagType = 'CreateLogisticCartTagType'
export const CreateLogisticFilialTagType = 'CreateLogisticFilialTagType'
export const CreateMqrTagType = 'CreateMqrTagType'

const api = createApi({
  baseQuery: baseQueryErrHandler,
  tagTypes: [
    CreateLogisticTagType,
    CreateLogisticCartTagType,
    CreateLogisticFilialTagType,
    CreateMqrTagType,
  ],
  endpoints: () => ({}),
})

export default api
